const { findByAddress } = require('@hints/utils/data');
const Interpretor = require('./interpretor');

module.exports = new Interpretor([
    {
        id: 'low-stress-reactivity',
        conditions: [{ id: 'score', min: 9, max: 17, value: e => findByAddress(e, 'evalSleep.fordAnswerScore') }],
    },
    {
        id: 'moderate-stress-reactivity',
        conditions: [{ id: 'score', min: 18, max: 23, value: e => findByAddress(e, 'evalSleep.fordAnswerScore') }],
    },
    {
        id: 'high-stress-reactivity',
        conditions: [{ id: 'score', min: 24, max: 30, value: e => findByAddress(e, 'evalSleep.fordAnswerScore') }],
    },
    {
        id: 'very-high-stress-reactivity',
        conditions: [{ id: 'score', min: 31, max: 36, value: e => findByAddress(e, 'evalSleep.fordAnswerScore') }],
    }
]);